import { api } from '@/service/http';
import store from '@/store';
import { computed } from 'vue';

// кастомный стор для трилиста.
// props:
// component - объект инстанса листа,
// loadOptions = { skip , mode, sort } (при сортировке приходит sort),
// data - ref , массив элементов,
// initArgs = { db_schema_name, db_view_name, token }

const metaData = computed(() => {
    return store.state.registryTreeList.regGrid;
});

export const treeListStore = async (component, loadOptions, data, initArgs, totalCount) => {
    // работа с приходящим фильтром
    let filters;
    if (!component) {
        return;
    }
    filters = component.getCombinedFilter();
    //преобразовываем и собираем в массив фильтров , который понимает бэк
    let parsedFilter = getParsedFilter(filters);
    const parentFilter = ['parent_id', '=', null];
    let accArr = [];
    if (parsedFilter) {
        accArr.push(parentFilter);
        accArr.push('and');
        accArr.push(parsedFilter);
    } else {
        accArr = parentFilter;
    }
    // работа с сортировкой объекта инстанса листа
    let sort = [];
    if (component) {
        var columns = component.state().columns;
        sort = loadOptions.sort ? loadOptions.sort : [];
        if (columns) {
            columns.forEach(col => {
                if (col.sortOrder) {
                    const sortItem = {
                        selector: col.name,
                        desc: col.sortOrder === 'desc',
                    };
                    sort.push(sortItem);
                }
            });
        }
    }
    if (sort && sort.length === 0) {
        const sortItem = {
            selector: 'name',
            desc: false,
        };
        sort.push(sortItem);
    }
    switch (loadOptions.mode) {
        case 'onScroll': {
            const args = {
                sort: sort && JSON.stringify(sort),
                skip: loadOptions.skip,
                take: 100,
                filter: JSON.stringify(accArr),
                meta: metaData.value,
                ...initArgs,
            };
            const result = await api(`meta./${initArgs.api}`, args);
            if (result && result.data) {
                totalCount = result.totalCount;
                data.push(...result.data);
            }
            break;
        }
        case 'onFilter': {
            const args = {
                skip: loadOptions.skip,
                sort: sort && JSON.stringify(sort),
                take: 100,
                filter: JSON.stringify(accArr),
                meta: metaData.value,
                ...initArgs,
            };
            const result = await api(`meta./${initArgs.api}`, args);
            if (result) {
                // customerVersListState.totalCount = result.count;
                totalCount = result.totalCount;
                data = result.data;
            }
            break;
        }
        case 'onClick':
            {
                let expandedRowKeys = component.option('expandedRowKeys');
                if (expandedRowKeys.length > 0) {
                    const filterExpanded = expandedRowKeys.map(el => {
                        return ['parent_id', '=', el];
                    });
                    const parentsIds = joinArraysWithSeparator(filterExpanded, 'or');
                    // при клике фильтры не отправляются на бэк, только айди родителей
                    const args = {
                        filter: JSON.stringify(parentsIds),
                        meta: metaData.value,
                        ...initArgs,
                    };
                    const result = await api(`meta./${initArgs.api}`, args);
                    if (result.data) {
                        const ids = result.data.map(el => {
                            return el.id;
                        });
                        data = data.filter(({ id }) => !ids.includes(id));
                        totalCount = result.totalCount;
                        data.push(...result.data);
                    }
                }
            }

            break;
    }
    if (loadOptions.mode === 'onFilter') {
        setTimeout(() => {
            const key = component.getKeyByRowIndex(0);
            component.scrollToItem && component.scrollToItem(key);
        }, 50);
    }
    if (loadOptions.loadingVisible) {
        loadOptions.loadingVisible.value = false;
    }
    return { data: data, totalCount: totalCount };
};

// helpers

export function getParsedFilter(input) {
    if (Array.isArray(input)) {
        let result = [];
        for (let i = 0; i < input.length; i++) {
            result.push(Array.isArray(input[i]) ? getParsedFilter(input[i]) : input[i]);
        }
        return result;
    } else {
        return input;
    }
}

function joinArraysWithSeparator(arrays, separator) {
    if (arrays.length === 1) {
        return arrays;
    }
    const res = [];
    arrays.forEach(el => {
        res.push(el);
        if (el !== arrays[arrays.length - 1]) res.push(separator);
    });
    return res;
}

export function containsInnerArrays(arr) {
    for (let i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i])) {
            return true;
        }
    }
    return false;
}
